
 export const ACTION_ICONS = {
  edit: { icon: "✏️", color: "#3498db" },
  add: { icon: "➕", color: "#2ecc71" },
  attach: { icon: "📎", color: "#95a5a6" },
  delete: { icon: "🗑️", color: "#e74c3c" },
  save: { icon: "💾", color: "#27ae60" },
  default: { icon: "⚙️", color: "#7f8c8d" }
};